
export { MainContent } from "/home/runner/work/play/play/apps/play-portal/src/components/layout/MainContent.tsx"